<template>
<modal name="miraiyu-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeMiraiyuDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに</p>
      <p style="font-size: 140%;">プロが好条件のドライバーの勤め先をご紹介します！</p>
      <br>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="true">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/driverswork_yagish_logo.png" style="width:80%" >
        </p>
      </div>
      <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
      <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
        (株)ミライユの<a href="https://miraiyu.co.jp/service-statement/" target="_blank">利用規約</a>、<a href="https://miraiyu.co.jp/service-statement/" target="_blank">個人情報保護方針</a>
      </p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談を希望する
        </p>
      </div>
      <div class="text-center" style="padding:10px">
        <el-button id="send-mynabi-pdf" type="success" v-if="isMiraiyuSended == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-miraiyu-consult');">希望する</el-button>
        <el-button id="send-mynabi-pdf" type="success" v-if="isMiraiyuSended == true"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeMiraiyuDialog();">送信しました</el-button>
        <br/>
      </div>
    </div>
  </div>
  <div class="setting" v-else-if="permissionType == 2">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
      <br>
      <p style="font-size: 140%;">正社員になれる！正社員転職できる！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに</p>
      <p style="font-size: 140%;">プロが好条件の勤め先をご紹介します！</p>
      <br>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="true">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/tanex_yagish_logo.png" style="width:80%" >
        </p>
      </div>
      <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
      <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
        (株)ミライユの<a href="https://miraiyu.co.jp/service-statement/" target="_blank">利用規約</a>、<a href="https://miraiyu.co.jp/service-statement/" target="_blank">個人情報保護方針</a>
      </p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意して無料相談を希望する
        </p>
      </div>
      <div class="text-center" style="padding:10px">
        <el-button id="send-mynabi-pdf" type="success" v-if="isMiraiyuSended == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-miraiyu-consult');">希望する</el-button>
        <el-button id="send-mynabi-pdf" type="success" v-if="isMiraiyuSended == true"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeMiraiyuDialog();">送信しました</el-button>
        <br/>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isMiraiyuSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openMiraiyuDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('miraiyu-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'miraiyu_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeMiraiyuDialog: function () {
      this.$modal.hide('miraiyu-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendMiraiyuConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'miraiyu_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendMiraiyu, formData, {timeout: 60000})
        .then(function (response) {
          app.isMiraiyuSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-miraiyu-consult', this.sendMiraiyuConsult)
    this.$eventHub.$on('open-miraiyu-dialog', this.openMiraiyuDialog)
    this.$eventHub.$on('popstate', this.closeMiraiyuDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-miraiyu-consult', this.sendMiraiyuConsult)
    this.$eventHub.$off('open-miraiyu-dialog', this.openMiraiyuDialog)
    this.$eventHub.$off('popstate', this.closeMiraiyuDialog)
  }
}
</script>
